

export interface PolicySummary {
  policy_number: string;
  funds_sum?: number;  // סכום בפוליסה
}

export interface InsightExtContext {
  batch_id?: string;  // מזהה באצ' משותף לכל התובנות של אותו תיק/משפחה
  total_funds_in_handler?: number;  // סה"כ סכום ביצרן
  policies_in_handler?: PolicySummary[];  // רשימת פוליסות ביצרן
  contact_ids?: number[];  // כל ה-contact_ids ביצרן (למשפחות)
}

export enum RuleType {
    EXPIRED_FEES = "EXPIRED_FEES",
    EXPIRED_TEMPORARY_RISK = "EXPIRED_TEMPORARY_RISK",
    EXPIRED_POWER_OF_ATTORNEY = "EXPIRED_POWER_OF_ATTORNEY",
    LOW_DISABILITY_COVERAGE = "LOW_DISABILITY_COVERAGE",
    HIGH_MANAGEMENT_FEE = "HIGH_MANAGEMENT_FEE",
    HIGH_MANAGEMENT_FEE_ALL = "HIGH_MANAGEMENT_FEE_ALL",
    HIGH_SAVING_FEE_FAMILY = "HIGH_SAVING_FEE_FAMILY",
    LOW_FUND_RETURN = "LOW_FUND_RETURN",
    LOW_FUND_RETURN_WITH_LOAN = "LOW_FUND_RETURN_WITH_LOAN", // תשואת קופה נמוכה בקופה עם הלוואה
    LOW_DISPERSION = "LOW_DISPERSION", // ✅ תובנה חדשה
    LOW_DISPERSION_FAMILY = "LOW_DISPERSION_FAMILY", // ✅ תובנה חדשה למשפחה
    LOW_STOCK_EXPOSURE = "LOW_STOCK_EXPOSURE", // ✅ חשיפה נמוכה למניות בקרנות השתלמות
    LOW_STOCK_EXPOSURE_FAMILY = "LOW_STOCK_EXPOSURE_FAMILY", // ✅ חשיפה נמוכה למניות בקרנות השתלמות - משפחה
    LOW_STOCK_EXPOSURE_LOAN = "LOW_STOCK_EXPOSURE_LOAN", // ✅ חשיפה נמוכה למניות בפוליסה עם הלוואה
    LOAN_ENDING_SOON = "LOAN_ENDING_SOON", // ✅ הלוואה עומדת להסתיים בעוד 3 חודשים
    SURVIVORS_WAIVER_EXPIRING = "SURVIVORS_WAIVER_EXPIRING", // ✅ ביטול כיסוי שארים עומד לפוג
    UNNECESSARY_SURVIVORS = "UNNECESSARY_SURVIVORS", // ✅ כיסוי שארים מיותר עבור רווק/ה
    MISSING_SURVIVORS = "MISSING_SURVIVORS", // ✅ חסר כיסוי שארים עבור נשוי/ידוע בציבור
    LONG_TERM_LOW_STOCK_EXP = "LONG_TERM_LOW_STOCK_EXP", // ✅ נזילות לטווח ארוך במסלול סולידי
    MISSING_DEPOSIT_WAIVER = "MISSING_DEPOSIT_WAIVER", // ✅ חסר שחרור מהפקדות בביטוח מנהלים
    LOW_DISABILITY_MANAGERS = "LOW_DISABILITY_MANAGERS", // ✅ שיעור כיסוי נכות נמוך מ-75% בביטוח מנהלים
    EDUCATION_GEMEL_SWAP = "EDUCATION_GEMEL_SWAP", // ✅ קרן השתלמות בחשיפה נמוכה וגמל להשקעה בחשיפה גבוהה
    CAPITAL_COMPONENT = "CAPITAL_COMPONENT", // ✅ רכיב הוני בביטוח מנהלים
    HIGH_FEE_INACTIVE_MGRS = "HIGH_FEE_INACTIVE_MGRS", // ✅ דמי ניהול מצבירה גבוהים בביטוח מנהלים לא פעיל
    HIGH_PENSION_FEE = "HIGH_PENSION_FEE", // ✅ דמי ניהול בפנסיה גבוהים מהמדרגות - תיק אישי
    PLUS_COVERAGE_MANAGERS = "PLUS_COVERAGE_MANAGERS" // ✅ ביטוח נוסף בביטוח מנהלים (מחלות קשות / מוות)


  }
export enum InsightStatus {
    PENDING = "PENDING",
    VALID = "VALID",
    IGNORED = "IGNORED",
    DONE = "DONE"
}
export class PolicyInsightsRuleBased {
  id: number;
  policy_number: string;
  handler_code: string;
  product_type: number;
  adjusted_product_type?: number;
  contact_id: number;
  mimshak_id: number;
  rule_type: RuleType;
  reported_period?: string;
  due_date?: Date;
  expired_value: number;
  funds_sum?: number;
  proposed_value?: number;
  status?: InsightStatus;
  is_pre_advice: boolean = false;
  fund_ids?: number[];
  notes?: string; // רשימת fund_ids בעייתיים
  data?: InsightExtContext;

}
